<template>
  <div id="root">
    <nav_home />
    <router-view></router-view>
  </div>
</template>
<script>
import nav_home from '@/components/nav_home.vue'
export default{
  components:{nav_home}
}
</script>
<style>
 html,body,#root,.localP{
   margin: 0;
   height: 100%;
   width: 100%;
   /* min-width:1000px */
 }
 @media screen and (max-width:1920px){
    html{
      font-size: 19.2px;
    }
 }
 @media screen and (max-width:1536px){
    html{
      font-size: 15.36px;
    }
 }
 @media screen and (max-width:1366px){
    html{
      font-size: 13.66px;
    }
 }
 button{
  cursor: pointer;
 }
</style>